import FanDemoGraphics from "components/FanDemoGraphics";
import Header from "components/Headers/Header";
import TabsInfoModal from "components/Modal/TabsInfoModal";
import TableComponent from "components/TableComponent";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import { getFanStatsFromApi } from "store/actions/fanDataAction";
import { getStates } from "store/actions/fanDataAction";
import { getFansData, blockUser } from "store/actions/fanDataAction";

const FansData = () => {
  let dispatch = useDispatch();
  const csvLink = useRef(null);
  const infoPoints = [
    "In the Fan module, the admin can view detailed information about each fan, including their name, email, location, and total earnings. The admin also has the option to block a fan and can use filters to search for fans with different account information.",
  ];
  const subPoints = [];
  const infoTitle = "Fans Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  let [filter, setFilter] = useState({
    gender: "",
    state: "",
    age: "",
    earnings: "",
    eduction: "",
    familyState: "",
  });
  const [Loader, setLoader] = useState({
    data: false,
    btn: false,
  });

  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
  ];
  let column = [
    "Fan Name",
    "Fan Email",
    "Gender",
    "Age",
    "Earings",
    "Eduction States",
    "Family States",
    "State",
  ];
  const keyMaps = {
    "Fan Name": "name",
    "Fan Email": "email",
    Gender: "gender",
    Age: "age",
    Earings: "income",
    "Eduction States": "education",
    "Family States": "familyStatus",
    State: "state",
  };
  const [switchBlockData, setSwitchBlockData] = useState({
    modal: false,
    condition: false,
    userId: "",
    loader: false,
  });
  const toggleBlockModal = () => {
    setSwitchBlockData((prev) => ({
      ...prev,
      modal: !prev.modal,
    }));
  };
  const handleSwitchBlock = () => {
    setSwitchBlockData((prev) => ({
      ...prev,
      loader: true,
    }));
    dispatch(
      blockUser(switchBlockData.condition, switchBlockData.userId, () => {
        setSwitchBlockData((prev) => ({
          ...prev,
          modal: false,
          condition: false,
          userId: "",
          loader: false,
        }));
      })
    );
  };

  const renderActions = (row) => (
    <>
      <Button
        size="sm"
        onClick={(e) => {
          e.preventDefault();
          toggleBlockModal();
          setSwitchBlockData((prev) => ({
            ...prev,
            condition: !row.blocked,
            userId: row.id,
          }));
        }}
      >
        <i className={`fa fa-ban ${row.blocked ? "text-danger" : ""} `}></i>
      </Button>
    </>
  );

  let { fansData, fanLastDocument, hasMoreDocumentFanData, states, fanStats } =
    useSelector((state) => state.fans);

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getFansData(filter, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(getStates());
    dispatch(getFanStatsFromApi());
  }, []);

  const getAge = (timestamp) => {
    const dateOfBirth = timestamp?.toDate();
    const currentDate = moment();
    return currentDate.diff(moment(dateOfBirth), "years");
  };

  const formatData = (data) => {
    return data.map((item) => ({
      ...item,
      age: getAge(item?.dateOfBirth),
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getFansData(filter, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };

  const handleClearFilter = () => {
    let newFilters = {
      gender: "",
      state: "",
      age: "",
      earnings: "",
      eduction: "",
      familyState: "",
    };
    setFilter((prev) => ({
      ...newFilters,
    }));

    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getFansData(newFilters, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };

  const handleLoadMore = () => {
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    dispatch(
      getFansData(filter, fanLastDocument, () => {
        setLoader((prev) => ({
          ...prev,
          btn: false,
        }));
      })
    );
  };
  const [isDemographic, setIsDemographic] = useState(true);

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row></Row>
        <div className="d-flex justify-content-end align-items-center mb-2">
          <Button
            color="primary"
            className="mt-2 mb-0 mr-2"
            onClick={() => setIsDemographic(!isDemographic)}
            disabled={Loader.data || fansData.length == 0}
          >
            {isDemographic ? "See Demographic" : "See Table"}
          </Button>
          <h2
            className="mb-0 mt-1 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </div>
        <Card className="px-4 pt-3 mb-4">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="gender">Gender</Label>
                  <Input
                    type="select"
                    name="gender"
                    id="gender"
                    value={filter.gender}
                    onChange={handleChange}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="state">State</Label>
                  <Input
                    type="select"
                    name="state"
                    id="state"
                    value={filter.state}
                    onChange={handleChange}
                  >
                    <option value="">Select State</option>
                    {states?.map((state) => (
                      <option key={state} value={state.name}>
                        {state.name}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="age">Age</Label>
                  <Input
                    type="text"
                    name="age"
                    id="age"
                    className="Fan_age"
                    placeholder="Enter Age"
                    value={filter.age}
                    onChange={handleChange}
                  />
                </FormGroup>
              </Col>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="earnings">Earnings</Label>
                  <Input
                    type="select"
                    name="earnings"
                    id="earnings"
                    value={filter.earnings}
                    onChange={handleChange}
                  >
                    <option value="">Select Earnings</option>
                    <option value="Up to $50,000 per year">
                      Up to $50,000 per year
                    </option>
                    <option value="Between $50,000 per year and $100,000 per year">
                      Between $50,000 per year and $100,000 per year
                    </option>
                    <option value="over $100,000 per year">
                      over $100,000 per year
                    </option>
                  </Input>
                </FormGroup>
              </Col>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="education">Education</Label>
                  <Input
                    type="select"
                    name="eduction"
                    id="education"
                    value={filter.eduction}
                    onChange={handleChange}
                  >
                    <option value="">Select Education</option>
                    <option value="Some high school">Some high school</option>
                    <option value="high school grad">High school grad</option>
                    <option value="some college">Some college</option>
                    <option value="college grad">College grad</option>
                    <option value="post grad or professional degree">
                      Post grad or professional degree
                    </option>
                  </Input>
                </FormGroup>
              </Col>
              <Col sm="6" md="4">
                <FormGroup>
                  <Label for="familyState">Family State</Label>
                  <Input
                    type="select"
                    name="familyState"
                    id="familyState"
                    value={filter.familyState}
                    onChange={handleChange}
                  >
                    <option value="">Select Family State</option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Married with children">
                      Married with children
                    </option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg="12" className="text-right pb-4">
                <div className="d-flex flex-column flex-sm-row justify-content-sm-end">
                  <CSVLink
                    ref={csvLink}
                    headers={headers}
                    filename={`FHP Fans ${moment(new Date()).format(
                      "DD-MM-YYYY"
                    )}.csv`}
                    data={
                      fansData == -1 || fansData == "loading"
                        ? []
                        : fansData.map((item) => {
                            return {
                              ...item,
                            };
                          })
                    }
                    className={`btn btn-primary mr-0 mr-sm-2 mb-2 mb-sm-0 ${
                      fansData.length === 0 ? "disabled" : ""
                    }`}
                  >
                    Export Emails
                  </CSVLink>
                  <Button
                    color="danger"
                    // disabled={fansData.length == 0}
                    className="mb-2 mb-sm-0 mr-0 mr-sm-2 ml-0 ml-sm-2"
                    onClick={handleClearFilter}
                  >
                    Clear Filters
                  </Button>
                  <Button
                    type="submit"
                    // disabled={fansData.length == 0}
                    className="ml-0 ml-sm-2"
                    color="primary"
                  >
                    Apply Filters
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Card>
        {Loader.data ? (
          <div className="text-center">
            <Spinner color="primary" />
          </div>
        ) : !isDemographic ? (
          <div className="">
            <h1
              className="text-center my-4
            "
            >
              TOTAL # OF FANS REGISTERED AT FHP:
              {Number(fanStats.male) + Number(fanStats.female)}
            </h1>
            <Row>
              <FanDemoGraphics
                series={[fanStats.male, fanStats.female]}
                labels={["Male", "Female"]}
                type="Gender"
                size={4}
              />
              <FanDemoGraphics
                series={[
                  fanStats.stateCounts.ALABAMA,
                  fanStats.stateCounts.ALASKA,
                  fanStats.stateCounts.ARIZONA,
                  fanStats.stateCounts.ARKANSAS,
                  fanStats.stateCounts.CALIFORNIA,
                  fanStats.stateCounts.COLORADO,
                  fanStats.stateCounts.CONNECTICUT,
                  fanStats.stateCounts.DELAWARE,
                ]}
                labels={[
                  "ALABAMA",
                  "ALASKA",
                  "ARIZONA",
                  "ARKANSAS",
                  "CALIFORNIA",
                  "COLORADO",
                  "CONNECTICUT",
                  "DELAWARE",
                ]}
                type="States"
                size={4}
              />
              <FanDemoGraphics
                series={[
                  fanStats.under_16_years_age,
                  fanStats._16_to_27_years_age,
                  fanStats._27_to_50_years_age,
                  fanStats._50_plus_years,
                ]}
                labels={[
                  "Under 16 years age",
                  "16 to 27 years age",
                  "27 to 50 year age",
                  "50 plus",
                ]}
                type="Age"
                size={4}
              />
              <FanDemoGraphics
                series={[
                  fanStats.up_to_50000_per_year,
                  fanStats.between_50000_and_100000_per_year,
                  fanStats.over_100000_per_year,
                  fanStats.skip,
                ]}
                labels={[
                  "Up to $50,000 per year",
                  "Between $50,000 per year and $100,000 per year",
                  "over $100,000 per year",
                  "Skip",
                ]}
                type="Earnings"
                size={4}
              />
              <FanDemoGraphics
                series={[
                  fanStats.some_high_school,
                  fanStats.high_school_grad,
                  fanStats.some_college,
                  fanStats.college_grad,
                  fanStats.post_grad_or_professional_degree,
                ]}
                labels={[
                  "Some high school",
                  "high school grad",
                  "some college",
                  "college grad",
                  "post grad or professional degree",
                ]}
                type="Education"
                size={4}
              />
              <FanDemoGraphics
                series={[
                  fanStats.single,
                  fanStats.married,
                  fanStats.married_with_children,
                ]}
                labels={["Single", "Married", "Married with children"]}
                type="Family State"
                size={4}
              />
            </Row>
          </div>
        ) : (
          <Card className="p-2">
            <TableComponent
              columns={column}
              data={formatData(fansData)}
              keyMap={keyMaps}
              renderActions={renderActions}
            />
            {fansData.length > 4 && (
              <div className="text-center py-4">
                <Button
                  color="primary"
                  onClick={handleLoadMore}
                  disabled={Loader.btn || !hasMoreDocumentFanData}
                >
                  {Loader.btn ? <Spinner size="sm" /> : "Load more"}
                </Button>
              </div>
            )}
          </Card>
        )}
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={switchBlockData.modal} centered toggle={toggleBlockModal}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to {switchBlockData.condition ? "block" : "unblock"} Fan.
            </span>
            <br />
            <br />
            <br />
            <Button
              color="primary"
              onClick={handleSwitchBlock}
              disabled={switchBlockData.loader}
            >
              {switchBlockData.loader ? <Spinner size="sm" /> : "Yes"}
            </Button>
            <Button color="danger" onClick={toggleBlockModal}>
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
export default FansData;
